<template>
  <div>
    <el-tabs v-model="activeName" type="border-card" class="maincard" @tab-click="clickTab">
      <el-tab-pane name="DividedTask">
				<span slot="label"><i class="iconfont icon-genzongdingwei"></i>每日派发单</span>
				<divided-task ref="DividedTask"></divided-task>
			</el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import DividedTask from './components/DividedTask'
export default {
  name: 'PhotoTaskStatistic',
  components: {
    DividedTask,
  },
  data() {
    return {
      activeName: 'DividedTask',
    }
  },
  mounted() {
    this.$refs.DividedTask.getList()
  },
  methods: {
    clickTab(tab) {
      if (tab.active) {
				this.$refs[tab.name].getList()
			}
    },
  },
}
</script>
<style scoped lang="less">
</style>
